export default __webpack_public_path__ + "static/media/github1.35a78ec8.svg";